<!-- KAN-712: phone layout. Below sm (640px) the page and card padding shrink,
     the headings step down, and the action buttons stack full width; from sm up
     the sizes are the same as before. -->
<div class="container mx-auto max-w-4xl p-4 sm:p-6" data-testid="certificate-viewer-page">
  <!-- Loading State -->
  @if (isLoading) {
    <div class="flex justify-center items-center py-20" role="status" aria-live="polite" data-testid="certificate-viewer-loading">
      <div class="loading loading-spinner loading-lg"></div>
      <span class="ml-4 text-base-content/70">Loading certificate...</span>
    </div>
  }

  <!-- Error Message -->
  @if (errorMessage) {
    <div class="alert alert-error mb-6" role="alert" data-testid="certificate-viewer-error-alert">
      <app-icon name="x-circle" type="heroicon" class="stroke-current shrink-0 h-6 w-6"></app-icon>
      <span>{{ errorMessage }}</span>
    </div>
  }

  <!-- Certificate Display -->
  @if (!isLoading && certificate) {
    <div class="certificate-container" role="main" aria-label="Certificate of completion">
      <div class="card bg-base-100 shadow-2xl border-4 border-primary certificate-border">
        <div class="card-body p-6 sm:p-12 text-center">
          <!-- Certificate Header -->
          <div class="border-b-2 border-base-300 pb-6 mb-6 sm:pb-8 sm:mb-8">
            <h1 class="text-2xl sm:text-4xl font-bold text-primary tracking-wide certificate-title">
              Certificate of Completion
            </h1>
          </div>
          <!-- Certificate Content -->
          <div class="space-y-6">
            <p class="text-lg font-medium text-base-content/70 tracking-widest uppercase">
              Presented to
            </p>
            <h2 class="text-2xl sm:text-4xl font-bold text-base-content tracking-wide user-name-display user-text-wrap"
                [title]="certificate.userName">
              {{ certificate.userName }}
            </h2>
            <!-- KAN-411 / KAN-363: a submission-only (non-gated) certificate must
                 say "completing", never "passing"/"certified" - it attests
                 completion, not an assessment outcome. Only a certificate issued
                 under an enforced pass gate may claim "passing". -->
            <p class="text-xl font-medium text-base-content/80" data-testid="certificate-completion-verb">
              For successfully {{ certificate.passingGateEnforced ? 'passing' : 'completing' }} the course
            </p>
            <h3 class="text-xl sm:text-3xl font-semibold text-primary tracking-wide course-name-display user-text-wrap"
                [title]="certificate.courseName">
              {{ certificate.courseName }}
            </h3>
            <p class="text-lg font-medium text-base-content/70 mt-8">
              Issued on {{ certificate.issuedAt | date:'longDate' }}
            </p>
            <div class="text-sm text-base-content/50 mt-8 sm:mt-12 font-medium tracking-widest user-text-wrap" data-testid="certificate-viewer-id">
              Certificate ID: {{ certificate.id }}
            </div>
          </div>
        </div>
      </div>
      <!-- Action Buttons -->
      <div class="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 mt-6 sm:mt-8 certificate-actions">
        <button
          (click)="printCertificate()"
          class="btn btn-success w-full sm:w-auto sm:btn-lg gap-2"
          data-testid="certificate-viewer-print-btn">
          <app-icon name="printer" type="heroicon" class="h-5 w-5"></app-icon>
          Print Certificate
        </button>
        <a routerLink="/courses" class="btn btn-outline w-full sm:w-auto sm:btn-lg gap-2" data-testid="certificate-viewer-back-btn">
          <app-icon name="arrow-left" type="heroicon" class="h-5 w-5"></app-icon>
          Back to Courses
        </a>
      </div>
    </div>
  }
</div>
